module.exports = __webpack_public_path__ + "static/bioestadistic-95e09fdd6bb1cb9fa5f0fe9627b7a86f.png";